import { Builder } from "@builder.io/react";

import { buildSlateColorTokens } from "./__internal__/buildSlateColorTokens";
import { buildTypographyDesignTokensFromFontRamp } from "./__internal__/buildTypographyDesignTokensFromFontRamp";

export const registerBuilderDesignTokens = () => {
  Builder.register("editor.settings", {
    designTokens: {
      fontFamily: buildTypographyDesignTokensFromFontRamp(),
      colors: buildSlateColorTokens(),
    },
  });
};
